export const PERFORMANCE_LOGGING_REQUEST = 'PERFORMANCE_LOGGING_REQUEST'
export const PERFORMANCE_LOGGING_SUCCESS = 'PERFORMANCE_LOGGING_SUCCESS'
export const PERFORMANCE_LOGGING_FAIL = 'PERFORMANCE_LOGGING_FAIL'